import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a75d848"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "active-txs"
}
const _hoisted_2 = { class: "flex flex-row items-center p-2 mb-3 justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Active Connext Transactions ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_ctx.active.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_n_text, { class: "uppercase text-lg font-semibold" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_n_text, { class: "opacity-70 text-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.active.length), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createVNode(_component_n_data_table, {
          bordered: false,
          columns: _ctx.columns,
          data: _ctx.active,
          pagination: _ctx.pagination
        }, null, 8 /* PROPS */, ["columns", "data", "pagination"])
      ]))
    : _createCommentVNode("v-if", true)
}